// extracted by mini-css-extract-plugin
export default {"employee-container":"Shift_employee-container__ev3Dl"};